<markant-dialog #SignupError [open]="this.dialogState" critical="true" class="signUpError">
  <div class="signUpErrorWrapper">
    <p>Mit den Daten ist bereits eine Registrierung vorhanden.</p>
    <p>Bitte wenden Sie sich an den Support.</p>
    <div class="signUpErrorButtonWrapper">
      <div>
        <p style="margin-bottom: 0; font-size: 75%">Hilfe benötigt?</p>
        <a href="mailto:accountmanagement@markant.net"><markant-button (click)="close()">Support</markant-button></a>
      </div>
      <markant-button (click)="close()">Schliessen</markant-button>
    </div>
  </div>
</markant-dialog>
